import { utcToZonedTime } from "date-fns-tz";

export const parseToUTCDate = (date: string | number | Date) => {
  return utcToZonedTime(date, "UTC");
};
